<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
    <!-- 商品图片 -->
    <div class="space-y-4">
      <div class="bg-white rounded-lg shadow-elevation-1 p-4">
        <img :src="product.image" alt="商品主图" class="w-full h-auto rounded-lg">
      </div>
      <div class="grid grid-cols-4 gap-2">
        <div class="bg-white rounded-lg shadow-elevation-1 p-2 cursor-pointer border-2 border-primary">
          <img :src="product.image" alt="商品缩略图" class="w-full h-auto rounded">
        </div>
        <div class="bg-white rounded-lg shadow-elevation-1 p-2 cursor-pointer hover:border-primary border-2 border-transparent">
          <img src="https://picsum.photos/400/400?random=11" alt="商品缩略图" class="w-full h-auto rounded">
        </div>
        <div class="bg-white rounded-lg shadow-elevation-1 p-2 cursor-pointer hover:border-primary border-2 border-transparent">
          <img src="https://picsum.photos/400/400?random=12" alt="商品缩略图" class="w-full h-auto rounded">
        </div>
        <div class="bg-white rounded-lg shadow-elevation-1 p-2 cursor-pointer hover:border-primary border-2 border-transparent">
          <img src="https://picsum.photos/400/400?random=13" alt="商品缩略图" class="w-full h-auto rounded">
        </div>
      </div>
    </div>

    <!-- 商品信息 -->
    <div class="space-y-6">
      <div class="bg-white rounded-lg shadow-elevation-1 p-6">
        <h1 class="text-2xl font-bold mb-2">{{ product.name }}</h1>
        
        <div class="flex items-center mb-4">
          <div class="flex text-warning mr-2">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star-half-o"></i>
          </div>
          <span class="text-neutral-500">{{ product.rating }} ({{ product.reviewCount }}条评价)</span>
          <span class="ml-4 text-primary">销量 {{ product.sales }}+</span>
        </div>
        
        <div class="border-t border-b border-neutral-200 py-4 mb-4">
          <div class="flex items-end mb-2">
            <span class="text-primary font-bold text-3xl">¥{{ product.price }}</span>
            <span class="text-neutral-400 line-through ml-3">¥{{ product.originalPrice }}</span>
            <span class="ml-3 bg-danger/10 text-danger px-2 py-1 rounded text-sm">-{{ Math.round((product.originalPrice - product.price)/product.originalPrice*100) }}%</span>
          </div>
          <div class="text-neutral-500 text-sm">
            配送至：<span class="text-primary">北京市朝阳区</span>
            <span class="ml-4">免运费</span>
          </div>
        </div>
        
        <!-- 规格选择 -->
        <div class="mb-6">
          <h3 class="font-medium mb-3">选择规格</h3>
          <div class="space-y-3">
            <div>
              <label class="block text-sm mb-2">颜色</label>
              <div class="flex flex-wrap gap-2">
                <button class="px-4 py-2 border border-primary bg-primary/5 rounded hover:bg-primary/10 transition-colors" v-for="color in product.colors" :key="color">
                  {{ color }}
                </button>
              </div>
            </div>
            
            <div>
              <label class="block text-sm mb-2">存储容量</label>
              <div class="flex flex-wrap gap-2">
                <button class="px-4 py-2 border border-primary bg-primary/5 rounded hover:bg-primary/10 transition-colors" v-for="capacity in product.capacities" :key="capacity">
                  {{ capacity }}
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 数量选择 -->
        <div class="mb-6">
          <h3 class="font-medium mb-3">购买数量</h3>
          <div class="flex items-center">
            <button class="w-10 h-10 border border-neutral-200 flex items-center justify-center hover:border-primary transition-colors" @click="decreaseQuantity">
              <i class="fa fa-minus"></i>
            </button>
            <input type="number" v-model="quantity" min="1" class="w-16 h-10 border-t border-b border-neutral-200 text-center focus:outline-none">
            <button class="w-10 h-10 border border-neutral-200 flex items-center justify-center hover:border-primary transition-colors" @click="increaseQuantity">
              <i class="fa fa-plus"></i>
            </button>
            <span class="ml-4 text-neutral-500 text-sm">库存 {{ product.stock }} 件</span>
          </div>
        </div>
        
        <!-- 操作按钮 -->
        <div class="flex gap-4">
          <button class="flex-1 bg-primary hover:bg-primary/90 text-white font-medium py-3 px-4 rounded-lg transition-colors" @click="addToCart">
            <i class="fa fa-shopping-cart mr-2"></i> 加入购物车
          </button>
          <button class="flex-1 bg-secondary hover:bg-secondary/90 text-white font-medium py-3 px-4 rounded-lg transition-colors" @click="buyNow">
            <i class="fa fa-bolt mr-2"></i> 立即购买
          </button>
        </div>
        
        <!-- 服务保障 -->
        <div class="mt-6 pt-6 border-t border-neutral-200">
          <div class="flex flex-wrap gap-4 text-sm text-neutral-500">
            <div class="flex items-center">
              <i class="fa fa-truck text-primary mr-2"></i>
              <span>满299元免运费</span>
            </div>
            <div class="flex items-center">
              <i class="fa fa-shield text-primary mr-2"></i>
              <span>正品保障</span>
            </div>
            <div class="flex items-center">
              <i class="fa fa-undo text-primary mr-2"></i>
              <span>7天无理由退换</span>
            </div>
            <div class="flex items-center">
              <i class="fa fa-headphones text-primary mr-2"></i>
              <span>24小时客服</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 促销信息 -->
      <div class="bg-white rounded-lg shadow-elevation-1 p-6">
        <h3 class="font-medium mb-3 flex items-center">
          <i class="fa fa-tag text-secondary mr-2"></i>
          促销优惠
        </h3>
        <ul class="space-y-2 text-sm">
          <li class="flex items-start">
            <i class="fa fa-check-circle text-success mt-1 mr-2"></i>
            <span>满2000减200，满5000减600</span>
          </li>
          <li class="flex items-start">
            <i class="fa fa-check-circle text-success mt-1 mr-2"></i>
            <span>白条3期免息，12期费率5折</span>
          </li>
          <li class="flex items-start">
            <i class="fa fa-check-circle text-success mt-1 mr-2"></i>
            <span>以旧换新最高补贴500元</span>
          </li>
          <li class="flex items-start">
            <i class="fa fa-check-circle text-success mt-1 mr-2"></i>
            <span>购买即赠价值199元配件礼包</span>
          </li>
        </ul>
      </div>
    </div>
    
    <!-- 商品详情标签页 -->
    <div class="lg:col-span-2 mt-8 bg-white rounded-lg shadow-elevation-1">
      <div class="border-b border-neutral-200">
        <ul class="flex">
          <li class="px-6 py-3 font-medium text-primary border-b-2 border-primary">商品详情</li>
          <li class="px-6 py-3 font-medium text-neutral-500 hover:text-primary cursor-pointer">规格参数</li>
          <li class="px-6 py-3 font-medium text-neutral-500 hover:text-primary cursor-pointer">用户评价 ({{ product.reviewCount }})</li>
          <li class="px-6 py-3 font-medium text-neutral-500 hover:text-primary cursor-pointer">售后保障</li>
        </ul>
      </div>
      
      <div class="p-6">
        <div class="space-y-6">
          <div>
            <h4 class="font-medium text-lg mb-4">商品介绍</h4>
            <div class="text-neutral-600 space-y-4">
              <p>{{ product.description }}</p>
              <img src="https://picsum.photos/1000/500?random=20" alt="商品详情" class="w-full h-auto rounded-lg my-4">
              <p>1. 超视网膜 XDR 显示屏，支持 ProMotion 自适应刷新率技术，最高可达 120Hz，带来流畅的视觉体验。</p>
              <p>2. A17 Pro 芯片，采用 3 纳米工艺制程，性能和能效双提升，轻松应对各类复杂任务。</p>
              <p>3. 专业级摄像头系统，支持 4K 60fps 视频拍摄，微距摄影，低光拍摄效果显著提升。</p>
              <p>4. 钛金属边框设计，更轻更坚固，提供更好的握持手感。</p>
              <p>5. 全天候电池续航，支持 20W 快充，30 分钟可充电至 50%。</p>
              <img src="https://picsum.photos/1000/500?random=21" alt="商品详情" class="w-full h-auto rounded-lg my-4">
              <p>6. 操作系统搭载最新版 iOS，提供丰富的功能和流畅的操作体验，定期更新带来更多新功能。</p>
              <p>7. 支持 Face ID 面部识别，提供安全快捷的解锁方式和支付体验。</p>
              <p>8. 防水防尘等级 IP68，可在 6 米水深停留最长 30 分钟，日常使用更安心。</p>
            </div>
          </div>
          
          <div>
            <h4 class="font-medium text-lg mb-4">包装清单</h4>
            <ul class="space-y-2 text-neutral-600">
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>主机 x 1</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>数据线 x 1</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>说明书 x 1</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>保修卡 x 1</span>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 class="font-medium text-lg mb-4">售后服务</h4>
            <ul class="space-y-2 text-neutral-600">
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>全国联保，享受三包服务</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>质保期：自签收之日起1年</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>如因质量问题或性能故障，凭华为客户服务中心出具的质量检测证明，可享受自物流签收后7日内退货，15日内换货</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check text-success mt-1 mr-2"></i>
                <span>15日以上在保修期内可享受免费维修等三包服务</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  data() {
    return {
      quantity: 1,
      product: {
        name: 'Apple iPhone 15 Pro 256GB 原色钛金属',
        price: 7999,
        originalPrice: 8999,
        rating: 4.8,
        reviewCount: 12580,
        sales: 50000,
        stock: 128,
        image: 'https://picsum.photos/400/400?random=10',
        colors: ['原色钛金属', '蓝色钛金属', '白色钛金属', '黑色钛金属'],
        capacities: ['128GB', '256GB', '512GB', '1TB'],
        description: 'iPhone 15 Pro 采用全新钛金属设计，更轻更坚固，配备 A17 Pro 芯片，带来前所未有的性能表现。超视网膜 XDR 显示屏支持 ProMotion 技术，刷新率高达 120Hz，显示效果更加流畅。专业级摄像头系统，让你轻松拍摄出媲美专业水平的照片和视频。'
      }
    }
  },
  methods: {
    increaseQuantity() {
      if (this.quantity < this.product.stock) {
        this.quantity++
      }
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    addToCart() {
      this.$bus.$emit('showMessage', '商品已加入购物车！')
    },
    buyNow() {
      this.$router.push('/checkout')
    }
  }
}
</script>